import axios from 'axios';
import { randomString } from '@utils/random';

if (process.env.REACT_APP_INITIAL_BACKEND_API_URL_ROOT) {
  axios.defaults.baseURL = process.env.REACT_APP_INITIAL_BACKEND_API_URL_ROOT;
} else {
  // Just assume the API url is the same as the page the code is loaded in.
  axios.defaults.baseURL = `https://${window.location.hostname}/api/`;
}

axios.defaults.headers['X-Client-Session-Id'] = randomString(32);
if (document.currentScript?.src) {
  const scriptFileName = document.currentScript.src.split('/').pop();
  axios.defaults.headers['X-Client-Version'] = scriptFileName;
}
axios.defaults.headers['X-Client-Tenant-Host'] = window.location.hostname;

axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      // Auth0.logout();
      return Promise.reject(error);
    }

    if (process.env.REACT_APP_DEBUG === 'true') {
      console.log(error.toString());
    } else {
      // Force reload the page. maybe this will help.
      // window.location.reload();
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

export { axios };
